import type { Component } from "vue";

export const routes = [
  {
    path: "/channels/manage",
    name: "channels-manager",
    component: (): Promise<Component> => import("./views/ManageChannels.vue"),
    meta: {
      requiresAuth: true,
      requiredRoles: ["accountManager"],
      requiredGroups: [],
    },
  },
];
